import { FC } from 'react';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from '../litres-audio-player/LitresAudioPlayer.module.scss';

interface ILitresAudioPlayer {
  externalId: number;
}

const LitresAudioPlayer: FC<ILitresAudioPlayer> = ({ externalId }) => {
  return (
    <div id="audio_player">
      <audio className={styles.audioPlayer} src={`${DEV_ABSOLUTE_URL}/trial/mp3/${externalId}.mp3`} controls={true} preload="none"></audio>
    </div>
  );
};

export default LitresAudioPlayer;
